// Audit jurnalidagi OBYEKT TURI — bir xil ko'rinishga keltirish.
//
// <h2>Nuqson #5 — nima ko'rinadi</h2>
// Jurnalning bir qatorida `SUBSCRIBER`, boshqasida `subscriber` turadi.
// Operator uchun bu ikki xil narsa bo'lib ko'rinadi: teglar ro'yxati ikki
// barobar uzayadi, filtrlash esa ishonchsiz bo'lib qoladi.
//
// <h2>⚠️ ILDIZI BACKENDDA — bu yerda faqat KO'RSATISH tuzatiladi</h2>
// `platform.audit_log.target_type` ga qiymat IKKI YO'LDAN tushadi va
// ikkalasi ham umumiy konstantaga tayanmaydi:
//
//   1. Servis o'zi yozadi — `AuditLog.ok(action, targetType, ...)` chaqiruvi
//      xom satr qabul qiladi. `xsib-identity`/`xsib-payments` katta harfda
//      yozadi (`"USER"`, `"PAYMENT"`, `"SUBSCRIBER"`), `xsib-agent` esa
//      KICHIK harfda (`AgentServiceImpl` → `"agent"`,
//      `DepositServiceImpl` → `"subscriber"`).
//   2. Qiymat umuman berilmasa `AuditEventConsumer` uni outbox
//      konvertidagi `aggregateType` dan oladi
//      (`firstNonBlank(text(payload,"targetType"), text(envelope,"aggregateType"))`).
//      U yerda esa agregat NOMI turadi, ya'ni `Subscriber` — Pascal shaklda.
//
// To'liq yechim — backendda umumiy enum va migratsiya bilan mavjud
// yozuvlarni normallashtirish. U bu topshiriq doirasidan tashqarida,
// shuning uchun panel qanday shakl kelsa ham BITTA ko'rinishga keltiradi.
//
// ⚠️ FILTR uchun bu funksiya ISHLATILMAYDI. Backend `target_type` ni
// AYNAN solishtiradi (`AuditLogRepository`), ya'ni normallashtirilgan
// qiymatni so'rovga qo'yish yozuvlarni yo'qotardi. Bu faqat ko'rsatish.

import type { Translate } from '@/shared/api/errors'

/**
 * Har qanday shaklni barqaror `UPPER_SNAKE` ga keltiradi.
 *
 *   `SUBSCRIBER` → `SUBSCRIBER`
 *   `subscriber` → `SUBSCRIBER`
 *   `Subscriber` → `SUBSCRIBER`
 *   `VoucherBatch` → `VOUCHER_BATCH`
 *   `voucher-batch` → `VOUCHER_BATCH`
 *
 * ⚠️ Katta harfga o'girishdan OLDIN so'z chegarasi qo'yiladi. Aks holda
 * `VoucherBatch` → `VOUCHERBATCH` bo'lib, `VOUCHER_BATCH` bilan
 * BOSHQA tur sifatida ko'rinardi — ya'ni tuzatish o'zi yangi nomuvofiqlik
 * yaratardi.
 */
export function normalizeObjectType(raw: string | null | undefined): string | null {
  if (!raw) return null
  const trimmed = raw.trim()
  if (trimmed === '') return null
  return trimmed
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[^a-zA-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toUpperCase()
}

/**
 * Obyekt turining odam o'qiydigan nomi.
 *
 * Tarjimasi bo'lmasa — normallashtirilgan KODNING O'ZI qaytadi, "Noma'lum"
 * emas. Sabab: backend biz bilmaydigan yangi tur qo'shishi mumkin va
 * `LEDGER_TXN` degan xom kod ham operatorga nimadir aytadi, "Noma'lum"
 * esa hech narsa aytmaydi va yozuvni tekshirib bo'lmaydigan qiladi.
 */
export function objectTypeLabel(raw: string | null | undefined, t: Translate): string | null {
  const code = normalizeObjectType(raw)
  if (code === null) return null
  return t(`audit.targetType.${code}`, { defaultValue: code })
}
